import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

export class AdvisorService {
  static async getAll(data) {
    const { limit, offset } = data;
    return await api.get(API_URLS.ADVISOR_V3, {
      params: { limit, offset, order: 'DESC' },
    });
  }

  static async getUsersForAdvisor() {
    return await api.get(API_URLS.USER_SEARCH_V3);
  }

  static async getAwaitApprove(data) {
    const { limit, offset, status } = data;
    return await api.get(API_URLS.ADVISORS_V3, {
      params: { limit, offset, status },
    });
  }

  static async activate(id) {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}/activate`);
  }

  static async deactivate(id) {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}/deactivate`);
  }

  static async create(data) {
    return await api.post(API_URLS.ADVISORS_V3, data);
  }

  static async update({ data, id }) {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}`, data);
  }

  static async reinvite(id) {
    return await api.put(API_URLS.ADVISOR_REINVITE, { userID: id });
  }

  static async delete(id) {
    return await api.delete(`${API_URLS.ADVISOR}/${id}`);
  }
}
